export default __webpack_public_path__ + "static/media/5-CloudOverTheMayor.2730216b.jpeg";